export enum SupportedPairingType {
    Binaural = 'Binaural',
    MonauralLeft = 'Monaural Left',
    MonauralRight = 'Monaural Right',
}
